import React, { Fragment, useEffect, useRef, useState } from "react";
import AppContext from "../Context/Context";
import axiosAuth from "../Axios/Interceptors";
import DragDrop from "../DragDrop/DragDrop";
import ApprovalsScreen from "./ApprovalsScreen";
import LoadingAnimation from "../LoadingAnimation/LoadingAnimation";
import moment from "moment";
import InputMaskReadOnly from "../App/InputMaskReadOnly";
import { useGlobalState } from "../Context/GlobalStateContext";
import DownloadPopup from "../App/DownloadPopup";
import DonutChart from "../Charts/DonutChart";
import Confirmation from "../App/Confirmation";
export default function ProgramStatus() {
  const [showAnimation, setShowAnimation] = useState(false);
  const globalState = useGlobalState();
  const [programList, setProgramList] = useState<any>([]);
  const [quarterList, setQuarterList] = useState<any>([]);
  const [showPopup, setShowPopup] = useState(false);

  const [approvalDataModal, setApprovalDataModal] = useState(false);
  const [showUserList, setShowUserList] = useState(false);
  const [JLRRecipientsList, setJLRRecipientsList] = useState<any>([]);
  const [ImporterRecipientsList, setImporterRecipientsList] = useState<any>([]);

  const [groupList, setGroupList] = useState<any>([]);
  const [programStatusDashboard, setProgramStatusDashboard] = useState<any>([]);
  const [formattedProgramStatusData, setFormattedProgramStatusData] =
    useState<any>([]);

  const [filterData, setFilterData] = useState({
    ProgramID: globalState.TopFilterData.IBBProgramID,
    QuarterID: globalState.TopFilterData.QuarterID,
    PFIGroupIDs: "1",
    IBBScorecardID: 0,
    PFIDealerID: 0,
    PFIBrandID: 2,
    TypeID: 10,
  });

  const [popUpMessageModal, setPopUpMessageModal] = useState(false);

  const [popUpMessage, setPopUpMessage] = useState();

  const [approvalUser, setApprovalUser] = useState([]) as any;
  const [approvalUserFiltered, setApprovalUserFiltered] = useState([]) as any;

  useEffect(() => {
    const search = window.location.search;
    const params = new URLSearchParams(search);

    let QuarterID = params.get("qid") as any;
    if (QuarterID && QuarterID != "") QuarterID = Number(QuarterID);
    else QuarterID = filterData.QuarterID;

    let IBBScorecardID = params.get("scid") as any;
    if (IBBScorecardID && IBBScorecardID != "")
      IBBScorecardID = Number(IBBScorecardID);
    else IBBScorecardID = filterData.IBBScorecardID;

    let PFIDealerID = params.get("dlid") as any;
    if (PFIDealerID && PFIDealerID != "") PFIDealerID = Number(PFIDealerID);
    else PFIDealerID = filterData.PFIDealerID;

    let IBBProgramID = params.get("pid") as any;
    if (IBBProgramID && IBBProgramID != "") IBBProgramID = Number(IBBProgramID);
    else IBBProgramID = filterData.ProgramID;

    setFilterData((prevState: any) => ({
      ...prevState,
      ProgramID: IBBProgramID,
      PFIDealerID: PFIDealerID,
      IBBScorecardID: IBBScorecardID,
      QuarterID: QuarterID,
    }));

    IBBProgramGetProgramListForScorecard(
      IBBProgramID,
      QuarterID,
      IBBScorecardID,
      PFIDealerID
    );
    IBBGroupGetCompleteGridData();
  }, []);

  useEffect(() => {
    IBBProgramGetDataForProgramStatusDashboard();
  }, [filterData]);

  useEffect(() => {
    if (programStatusDashboard && programStatusDashboard.length > 0)
      formatSectionAndCriteriaInputDataForDetailsScorecard();
  }, [programStatusDashboard]);

  function IBBProgramGetProgramListForScorecard(
    IBBProgramID: number,
    QuarterID: number,
    IBBScorecardID: number,
    PFIDealerID: number
  ) {
    if (IBBProgramID == 0) IBBProgramID = filterData.ProgramID;
    let object = {} as any;
    object.appid = AppContext.App;
    object.isdeleted = false;
    object.ibbprogramid = IBBProgramID;
    object.numericquarter = QuarterID;
    object.pfidealerid = PFIDealerID;
    setShowAnimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL +
          "api/IBBProgram/IBBProgramGetProgramListForScorecard",
        object
      )
      .then((response) => {
        setShowAnimation(false);
        if (response.data.Status == 1) {
          let result = response.data.Data;
          if (result.length > 1 && result[0].length > 0) {
            setProgramList(result[0]);
            if (IBBProgramID == 0) {
              IBBProgramID = result[0][0].IBBProgramID;
              setFilterData((prevState: any) => ({
                ...prevState,
                ProgramID: IBBProgramID,
              }));
            }

            setQuarterList(result[2]);
            if (QuarterID == 0) {
              let QuarterID = result[2][0].PID;
              setFilterData((prevState: any) => ({
                ...prevState,
                QuarterID: QuarterID,
              }));
            }
          }
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function IBBGroupGetCompleteGridData() {
    let object = {} as any;
    object.appid = AppContext.App;
    object.isdeleted = false;
    object.recordsperpage = 1000;
    object.sortexpressions = "Description";
    object.sortdirection = "D";
    setShowAnimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL + "api/IBBGroup/IBBGroupGetCompleteGridData",
        object
      )
      .then((response) => {
        setShowAnimation(false);
        if (response.data.Status === 1) {
          let result = response.data.Data;
          if (result.length > 1) {
            if (result[1].length > 0) {
            }
            setGroupList(result[1]);
          }
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function IBBProgramGetDataForProgramStatusDashboard() {
    let object = {} as any;
    object.appid = AppContext.App;
    object.ibbprogramid = filterData.ProgramID;
    object.quarterid = filterData.QuarterID;
    object.pfigroupids = filterData.PFIGroupIDs;
    object.typeid = filterData.TypeID;
    setShowAnimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL +
          "api/IBBProgram/IBBProgramGetDataForProgramStatusDashboard",
        object
      )
      .then((response) => {
        setShowAnimation(false);
        if (response.data.Status == 1) {
          let result = response.data.Data;
          setProgramStatusDashboard(result);
          setApprovalUser(result[4]);
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function formatSectionAndCriteriaInputDataForDetailsScorecard() {
    let importerListLocal = [...programStatusDashboard[1]];
    for (let i = 0; i < importerListLocal.length; i++) {
      for (let j = 0; j < programStatusDashboard[2].length; j++) {
        let IBBScorecardID = importerListLocal[i].IBBScorecardID;
        let IBBProgramSectionID =
          programStatusDashboard[2][j].IBBProgramSectionID;
        let Title = programStatusDashboard[2][j].IBBProgramSectionName;

        importerListLocal[i][Title + "InputClass"] = "";
        importerListLocal[i][Title + "EnteredInputCount"] = "";
        importerListLocal[i][Title + "TotalInputCount"] = "";
        importerListLocal[i][Title + "ApprovalClass"] = "";
        importerListLocal[i][Title + "TotalApprovalCount"] = "";
        importerListLocal[i][Title + "ApprovedApprovalCount"] = "";

        var filtered = programStatusDashboard[3].filter(
          (item: any) =>
            item.IBBScorecardID == IBBScorecardID &&
            item.IBBProgramSectionID == IBBProgramSectionID
        );
        if (filtered.length > 0) {
          importerListLocal[i][Title + "InputClass"] = filtered[0].InputClass;
          importerListLocal[i][Title + "EnteredInputCount"] =
            filtered[0].EnteredInputCount;
          importerListLocal[i][Title + "TotalInputCount"] =
            filtered[0].TotalInputCount;
          importerListLocal[i][Title + "ApprovalClass"] =
            filtered[0].ApprovalClass;
          importerListLocal[i][Title + "TotalApprovalCount"] =
            filtered[0].TotalApprovalCount;
          importerListLocal[i][Title + "ApprovedApprovalCount"] =
            filtered[0].ApprovedApprovalCount;
        }
      }
    }

    setFormattedProgramStatusData(importerListLocal);
  }

  function IBBProgramUpdateProgramScorecardStatusAndHandleActions(
    Status: number,
    SubStatus: number,
    Type: number,
    ActionType: number
  ) {
    let object = {} as any;
    object.appid = AppContext.App;
    object.ibbprogramid = filterData.ProgramID;
    object.quarterid = filterData.QuarterID;
    object.ibbscorecardid = filterData.IBBScorecardID;
    object.type = Type;
    object.status = Status;
    object.substatus = SubStatus;
    object.actiontype = ActionType;
    object.pfigroupids = filterData.PFIGroupIDs;
    if (SubStatus != undefined && SubStatus > 0) {
      setShowAnimation(true);
      axiosAuth
        .post(
          AppContext.AppBaseURL +
            "api/IBBProgram/IBBProgramUpdateProgramScorecardStatusAndHandleActions",
          object
        )
        .then((response) => {
          setShowAnimation(false);
          if (response.data.Status === 1) {
            let result = response.data.Data;
            setShowPopup(true);
          } else {
            AppContext.ShowNotification("error", response.data.Message);
          }
        })
        .catch((error) => {
          console.error("There was an error!", error);
        });
    } else AppContext.ShowNotification("error", "Please select stage.");
  }

  function GetUserListApplicationAccessSettingsForAccessObject(
    AccessType: number,
    ObjectID: number
  ) {
    let object = {} as any;
    object.appid = AppContext.App;
    object.accesstype = AccessType;
    object.objectid = ObjectID;
    object.ibbscorecardid = filterData.IBBScorecardID;
    object.pfigroupids = filterData.PFIGroupIDs;
    setShowAnimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL +
          "api/IBBProgram/GetUserListApplicationAccessSettingsForAccessObject",
        object
      )
      .then((response) => {
        setShowAnimation(false);
        if (response.data.Status === 1) {
          let result = response.data.Data;
          if (result.length > 1) {
            setJLRRecipientsList(result[0]);
            setImporterRecipientsList(result[1]);
          }
          setShowUserList(true);
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function ConfirmationCallBack(obj: any) {
    if (obj.isConfirm === true) {
      if (obj.ID == 1) {
        IBBProgramUpdateProgramScorecardStatusAndHandleActions(
          2,
          2,
          obj.SelectedID,
          1
        );
      }
      if (obj.ID == 2) {
        IBBProgramUpdateProgramScorecardStatusAndHandleActions(
          3,
          1,
          obj.SelectedID,
          2
        );
      }
      if (obj.ID == 3) {
        IBBProgramUpdateProgramScorecardStatusAndHandleActions(
          3,
          5,
          obj.SelectedID,
          3
        );
      }
      if (obj.ID == 4) {
        IBBProgramUpdateProgramScorecardStatusAndHandleActions(
          3,
          6,
          obj.SelectedID,
          4
        );
      }
      if (obj.ID == 6 || obj.ID == 7) {
        IBBProgramUpdateProgramScorecardStatusAndHandleActions(
          4,
          4,
          obj.SelectedID,
          6
        );
      }
    }
    globalState.setConfirmationObject({
      ShowPopup: false,
      Heading: "",
      Message: "",
      ID: 0,
      SelectedID: 0,
    });
  }

  function showApprovalsData(
    IBBScorecardID: number,
    IBBProgramSectionID: number
  ) {
    var filtered = approvalUser.filter(
      (item: any) =>
        item.IBBScorecardID == IBBScorecardID &&
        item.IBBProgramSectionID == IBBProgramSectionID
    );
    setApprovalUserFiltered(filtered);
    setApprovalDataModal(true);
  }
  return (
    <>
      {showAnimation && <LoadingAnimation />}
      <Confirmation
        ConfirmationObject={globalState.ConfirmationObject}
        ConfirmationCallBack={ConfirmationCallBack}
      />

      <div className="page--contents">
        <div className="page--breadcrumb">
          <a>Program Status</a>
        </div>
        <div className="page--data">
          <div className="flex-container">
            <div style={{ width: "33.33%" }}>
              <select
                className="select-md"
                value={filterData.ProgramID}
                onChange={(e) => {
                  setFilterData((prevState: any) => ({
                    ...prevState,
                    ProgramID: Number(e.target.value),
                    QuarterID: 0,
                    IBBScorecardID: 0,
                  }));
                  globalState.setTopFilterData((prevState: any) => ({
                    ...prevState,
                    IBBProgramID: Number(e.target.value),
                    QuarterID: 0,
                  }));
                  IBBProgramGetProgramListForScorecard(
                    Number(e.target.value),
                    0,
                    0,
                    0
                  );
                }}
              >
                {programList &&
                  programList.map((Item: any, index: any) => (
                    <option value={Item.PID} key={"programtop" + Item.PID}>
                      {Item.Name}
                    </option>
                  ))}
              </select>

              <select
                style={{ marginLeft: 5 }}
                className="select-md"
                value={filterData.QuarterID}
                onChange={(e) => {
                  setFilterData((prevState: any) => ({
                    ...prevState,
                    QuarterID: Number(e.target.value),
                    IBBScorecardID: 0,
                  }));
                  globalState.setTopFilterData((prevState: any) => ({
                    ...prevState,
                    QuarterID: Number(e.target.value),
                  }));
                }}
              >
                {quarterList &&
                  quarterList.map((Item: any, index: any) => (
                    <option value={Item.PID} key={"quartertop" + Item.PID}>
                      {Item.Name}
                    </option>
                  ))}
              </select>
            </div>
            <div>
              <select
                className="select-md"
                value={filterData.PFIGroupIDs}
                onChange={(e) =>
                  setFilterData((prevState: any) => ({
                    ...prevState,
                    PFIGroupIDs: Number(e.target.value),
                    ExceptionID: -1,
                  }))
                }
              >
                {groupList &&
                  groupList.map((item: any, index: any) => (
                    <option value={item.IBBGroupID} key={"groupoption" + index}>
                      {item.Name}
                    </option>
                  ))}
              </select>
            </div>
            <span style={{ width: "33.33%" }}></span>
          </div>
          <div className="page--tabs">
            <a
              className={filterData.TypeID == 10 ? "tab active" : "tab"}
              onClick={() =>
                setFilterData((prevState: any) => ({
                  ...prevState,
                  TypeID: 10,
                }))
              }
            >
              Targets
              <span className="chevron"></span>
            </a>
            <a
              className={filterData.TypeID == 13 ? "tab active" : "tab"}
              onClick={() =>
                setFilterData((prevState: any) => ({
                  ...prevState,
                  TypeID: 13,
                }))
              }
            >
              Actuals
              <span className="chevron"></span>
            </a>
          </div>

          <div className="input-approvals">
            {programStatusDashboard && programStatusDashboard[0] && (
              <div className="donuts-flex">
                <div className="donut-box">
                  <span className="donut-box-head">Inputs</span>
                  <div className="donut-box-flex">
                    <DonutChart
                      data={[
                        {
                          name: "Input",
                          value:
                            programStatusDashboard[0][0].EnteredInputCount?.toLocaleString(
                              undefined,
                              { minimumFractionDigits: 0 }
                            ),
                          color: "#98cb4a",
                        },
                        {
                          name: "Pending Input",
                          value:
                            Number(
                              programStatusDashboard[0][0].TotalInputCount
                            ) -
                            Number(
                              programStatusDashboard[0][0].EnteredInputCount
                            ),
                          color: "#f5f5f5",
                        },
                      ]}
                      totalValueToPrint={
                        programStatusDashboard[0][0].EnteredInputCount?.toLocaleString(
                          undefined,
                          { minimumFractionDigits: 0 }
                        ) +
                        " of " +
                        programStatusDashboard[0][0].TotalInputCount?.toLocaleString(
                          undefined,
                          { minimumFractionDigits: 0 }
                        )
                      }
                      showTextOnGraph={0}
                      innerRadius={1.2}
                    ></DonutChart>
                  </div>
                </div>
                <div className="donut-box">
                  <span className="donut-box-head">Approvals</span>
                  <div className="donut-box-flex">
                    <DonutChart
                      data={[
                        {
                          name: "Approved",
                          value:
                            programStatusDashboard[0][0].ApprovedApprovalCount?.toLocaleString(
                              undefined,
                              { minimumFractionDigits: 0 }
                            ),
                          color: "#98cb4a",
                        },
                        {
                          name: "Pending Approvals",
                          value:
                            Number(
                              programStatusDashboard[0][0].TotalApprovalCount
                            ) -
                            Number(
                              programStatusDashboard[0][0].ApprovedApprovalCount
                            ),
                          color: "#f5f5f5",
                        },
                      ]}
                      totalValueToPrint={
                        programStatusDashboard[0][0].ApprovedApprovalCount?.toLocaleString(
                          undefined,
                          { minimumFractionDigits: 0 }
                        ) +
                        " of " +
                        programStatusDashboard[0][0].TotalApprovalCount?.toLocaleString(
                          undefined,
                          { minimumFractionDigits: 0 }
                        )
                      }
                      showTextOnGraph={0}
                      innerRadius={1.2}
                    ></DonutChart>
                  </div>
                </div>
                <div className="Legend-main3 status-legends">
                  <div className="leg-item">
                    <span className="GrayClass"></span>
                    <p>N/A</p>
                  </div>
                  <div className="leg-item">
                    <span className="RedClass"></span>
                    <p>Pending</p>
                  </div>
                  <div className="leg-item">
                    <span className="OrangeClass"></span>
                    <p>Partial</p>
                  </div>

                  <div className="leg-item">
                    <span className="GreenClass"></span>
                    <p>Done</p>
                  </div>
                </div>
              </div>
            )}

            {/* <div className="share-targets">
              {filterData.TypeID == 10 && (
                <>
                  <div className="btn-shar-targets">
                    <a
                      className=""
                      onClick={() => {
                        globalState.setConfirmationObject({
                          ShowPopup: true,
                          Heading: "Confirmation - Share Targets To Importers",
                          Message:
                            "Are you sure you want to share the targets?",
                          ID: 1,
                          SelectedID: 1,
                        });
                      }}
                    >
                      Share Targets To Importers
                    </a>
                  </div>
                  <div className="btn-shar-targets">
                    <span
                      className="pointer"
                      onClick={() => {
                        GetUserListApplicationAccessSettingsForAccessObject(
                          3,
                          2
                        );
                      }}
                    >
                      <img
                        src="images/users.svg"
                        width={28}
                        height={28}
                        alt="info"
                      />
                    </span>
                    <a
                      onClick={() => {
                        globalState.setConfirmationObject({
                          ShowPopup: true,
                          Heading:
                            "Confirmation - Send Targets Email To Importers",
                          Message: "Are you sure you want to send this email?",
                          ID: 1,
                          SelectedID: 2,
                        });
                      }}
                    >
                      Send Targets Email To Importers
                    </a>
                  </div>
                </>
              )}

              {filterData.TypeID == 13 && (
                <>
                  <div className="btn-shar-targets btn-shar-targets-2">
                    <a
                      onClick={() => {
                        globalState.setConfirmationObject({
                          ShowPopup: true,
                          Heading:
                            "Confirmation - Share Initial Actual Scorecard",
                          Message:
                            "Are you sure you want to share the Initial Actuals?",
                          ID: 3,
                          SelectedID: 1,
                        });
                      }}
                    >
                      Share Initial Actual Scorecard
                    </a>
                  </div>
                  <div className="btn-shar-targets btn-shar-targets-2">
                    <span
                      title="Get Recipients List"
                      className="pointer"
                      onClick={() => {
                        GetUserListApplicationAccessSettingsForAccessObject(
                          3,
                          4
                        );
                      }}
                    >
                      <img
                        src="images/users.svg"
                        width={28}
                        height={28}
                        alt="info"
                      />
                    </span>
                    <a
                      onClick={() => {
                        globalState.setConfirmationObject({
                          ShowPopup: true,
                          Heading:
                            "Confirmation - Share Initial Actual Scorecard",
                          Message: "Are you sure you want to send this email?",
                          ID: 3,
                          SelectedID: 2,
                        });
                      }}
                    >
                      Send Initial Actual Scorecard Email To Importers
                    </a>
                  </div>
                </>
              )}
            </div> */}
          </div>

          {programStatusDashboard && programStatusDashboard[2] && (
            <div
              className="section-table table-p-status"
              style={{ boxShadow: "none", padding: 0 }}
            >
              <table
                className="part-head trend-table fixed-table"
                id="tblIBBCriteriaProgram"
              >
                <thead>
                  <tr>
                    <th rowSpan={2}></th>
                    {programStatusDashboard[2] &&
                      programStatusDashboard[2].map((item: any, index: any) => (
                        <React.Fragment key={"sectionheadinga" + index}>
                          <th colSpan={2}>
                            <div className="flex-items justify-center">
                              {item.IBBProgramSectionName}
                              <a
                                className="eye-th"
                                title="Targets & Actuals"
                                target="_blank"
                                href={
                                  "bulkinput?pid=" +
                                  filterData.ProgramID +
                                  "&qid=" +
                                  filterData.QuarterID +
                                  "&secid=" +
                                  item.IBBProgramSectionID
                                }
                              >
                                <img
                                  src="images/eye.svg"
                                  width="16px"
                                  height="11px"
                                  alt="Eye"
                                />
                              </a>
                            </div>
                          </th>
                        </React.Fragment>
                      ))}
                  </tr>
                  <tr>
                    {programStatusDashboard[2] &&
                      programStatusDashboard[2].map((item: any, index: any) => (
                        <React.Fragment key={"sectionheadingb" + index}>
                          <th>Input</th>
                          <th>Approval</th>
                        </React.Fragment>
                      ))}
                  </tr>
                </thead>
                <tbody>
                  {formattedProgramStatusData &&
                    formattedProgramStatusData.map((item: any, index: any) => (
                      <React.Fragment key={"ReEarnableCount" + index}>
                        <tr>
                          <td>{item.ImporterName}</td>

                          {programStatusDashboard[2] &&
                            programStatusDashboard[2].map(
                              (sectionitem: any, sectionindex: any) => (
                                <React.Fragment
                                  key={"index" + index + sectionindex}
                                >
                                  <>
                                    <td
                                      className={
                                        item[
                                          sectionitem.IBBProgramSectionName +
                                            "InputClass"
                                        ]
                                      }
                                    >
                                      {item[
                                        sectionitem.IBBProgramSectionName +
                                          "EnteredInputCount"
                                      ] +
                                        "/" +
                                        item[
                                          sectionitem.IBBProgramSectionName +
                                            "TotalInputCount"
                                        ]}
                                    </td>

                                    <td
                                      onClick={(e) => {
                                        showApprovalsData(
                                          item.IBBScorecardID,
                                          sectionitem.IBBProgramSectionID
                                        );
                                      }}
                                      className={
                                        item[
                                          sectionitem.IBBProgramSectionName +
                                            "ApprovalClass"
                                        ]
                                      }
                                    >
                                      {item[
                                        sectionitem.IBBProgramSectionName +
                                          "ApprovedApprovalCount"
                                      ] +
                                        "/" +
                                        item[
                                          sectionitem.IBBProgramSectionName +
                                            "TotalApprovalCount"
                                        ]}
                                    </td>
                                  </>
                                </React.Fragment>
                              )
                            )}
                        </tr>
                      </React.Fragment>
                    ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>

      {popUpMessageModal && (
        <div className="popup-help">
          <div className="help-popup-display">
            <div className="help-inner">
              <div className="help-head">
                <h3>Message</h3>
                <a
                  className="close-help"
                  onClick={() => setPopUpMessageModal(false)}
                >
                  <img
                    src="/images/close.svg"
                    width="15px"
                    height="15px"
                    alt="cross"
                  />
                </a>
              </div>
              <div className="buis-case plr-20">{popUpMessage}</div>
            </div>
          </div>
        </div>
      )}

      {showUserList && (
        <div className="popup-help">
          <div className="help-popup-display">
            <div className="help-inner rec-help" style={{ paddingBottom: 10 }}>
              <div className="help-head" style={{ margin: 0 }}>
                <h3>Recipients</h3>
                <a
                  className="close-help"
                  onClick={() => setShowUserList(false)}
                >
                  <img
                    src="/images/close.svg"
                    width="15px"
                    height="15px"
                    alt="cross"
                  />
                </a>
              </div>
              <div className="rec-grid">
                {JLRRecipientsList.length > 0 && (
                  <div className="rec-list">
                    <span className="rec-head">All Brands Recipients:</span>
                    <ul>
                      {JLRRecipientsList &&
                        JLRRecipientsList.map((item: any, index: any) => (
                          <React.Fragment key={"jlruser" + index}>
                            {1 == 1 && (
                              <li>
                                {item.FirstName} {item.LastName} ({item.Email})
                              </li>
                            )}
                          </React.Fragment>
                        ))}
                    </ul>
                  </div>
                )}
                {ImporterRecipientsList.length > 0 && (
                  <div className="rec-list">
                    <span className="rec-head">Importer Recipients:</span>
                    <ul>
                      {ImporterRecipientsList &&
                        ImporterRecipientsList.map((item: any, index: any) => (
                          <React.Fragment key={"jlruser" + index}>
                            {1 == 1 && (
                              <li>
                                {item.DealerName}: {item.FirstName}{" "}
                                {item.LastName} ({item.Email})
                              </li>
                            )}
                          </React.Fragment>
                        ))}
                    </ul>
                  </div>
                )}
              </div>
              <div className="help-btns">
                <a onClick={() => setShowUserList(false)}>Close</a>
              </div>
            </div>
          </div>
        </div>
      )}

      {showPopup && (
        <div className="popup-help">
          <div className="help-popup-display">
            <div className="help-inner" style={{ paddingBottom: 10 }}>
              <div className="help-head" style={{ margin: 0 }}>
                <h3>Message</h3>
                <a className="close-help" onClick={() => setShowPopup(false)}>
                  <img
                    src="/images/close.svg"
                    width="15px"
                    height="15px"
                    alt="cross"
                  />
                </a>
              </div>
              <div className="section-table copa-sum-tab">
                Email has been scheduled and will be sent out shortly.
              </div>
              <div className="help-btns">
                <a onClick={() => setShowPopup(false)}>Close</a>
              </div>
            </div>
          </div>
        </div>
      )}

      {approvalDataModal && (
        <div className="popup-help">
          <div className="help-popup-display">
            <div className="help-inner">
              <div className="help-head" style={{ marginBottom: 0 }}>
                <h3>Approvals</h3>
                <a
                  className="close-help"
                  onClick={() => setApprovalDataModal(false)}
                >
                  <img
                    src="/images/close.svg"
                    width="15px"
                    height="15px"
                    alt="cross"
                  />
                </a>
              </div>
              <div
                className="plr-20 bulk-padding"
                style={{ maxHeight: 550, overflow: "auto", paddingBottom: 20 }}
              >
                <div
                  className="appr-main show-title"
                  style={{
                    padding: 10,
                    paddingTop: 0,
                    width: "100%",
                    marginTop: 10,
                  }}
                >
                  <div className="pg-importers appr-grid grid-signoff">
                    <div className="exceptions-right">
                      {approvalUserFiltered &&
                        approvalUserFiltered.map((itemUser: any, indexUser: any) => (
                          <React.Fragment
                            key={"requiredapprovaluser" + indexUser}
                          >
                            <>
                              <div className="">
                                <div className="req-by">
                                  <div className="req-left">
                                    <div className="req-title"></div>
                                    <span className="req-val">
                                      {itemUser.JobRoleTitle != "" && (
                                        <> {itemUser.JobRoleTitle} / </>
                                      )}

                                      {itemUser.UserName}
                                      {itemUser.Status != 0 && (
                                        <>
                                          {itemUser.OnBehalfText != "" && (
                                            <span className="signed-by">
                                              ({itemUser.OnBehalfText})
                                            </span>
                                          )}
                                        </>
                                      )}
                                    </span>
                                  </div>
                                  {itemUser.Status != 0 && (
                                    <div className="req-center">
                                      <span>
                                        {moment(itemUser.ApprovalTime)?.format(
                                          "MMMM DD, YYYY hh:mm"
                                        )}
                                      </span>
                                    </div>
                                  )}
                                  <div className="req-right">
                                    {itemUser.FileURL && (
                                      <a
                                        href={itemUser.FileURL}
                                        target="blank"
                                        title="Click to download attachment"
                                      >
                                        1
                                      </a>
                                    )}
                                    {itemUser.Notes && (
                                      <a
                                        onClick={() => {
                                          setPopUpMessage(itemUser.Notes);
                                          setPopUpMessageModal(true);
                                        }}
                                        title={itemUser.Notes}
                                      >
                                        <img
                                          src="images/message.svg"
                                          width={15}
                                          height={15}
                                        />
                                      </a>
                                    )}

                                    {itemUser.Status > 0 && (
                                      <>
                                        {itemUser.Status == 1 && (
                                          <span className="req-yes">
                                            <> APPROVED</>
                                          </span>
                                        )}
                                        {itemUser.Status == 2 && (
                                          <span className="req-yes req-no">
                                            <> REJECTED</>
                                          </span>
                                        )}
                                      </>
                                    )}
                                    {itemUser.Status == 0 && (
                                      <>
                                        <span className="req-pend">
                                          PENDING
                                        </span>
                                      </>
                                    )}
                                  </div>
                                </div>
                              </div>

                              {itemUser.IsStartSection && (
                                <div className="req-hr"></div>
                              )}
                            </>
                          </React.Fragment>
                        ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
